/**
 * Horizontal divider with a label nestled in the middle (e.g., "or").
 * Used between the OAuth row and the email-form row on Login + Signup.
 */
export interface DividerProps {
  label: string
}

export function Divider({ label }: DividerProps) {
  return (
    <div className="relative">
      <div className="absolute inset-0 flex items-center">
        <span className="w-full border-t" />
      </div>
      <div className="relative flex justify-center text-xs uppercase">
        <span className="bg-card px-2 text-muted-foreground">{label}</span>
      </div>
    </div>
  )
}
